import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: 12,
        padding: "0px 22px 22px 22px",
    },
    contentTableExpandedRow: {
        backgroundColor: `${theme.palette.backgrounds.main} !important`,
        " & td": {
            padding: "8px 16px !important",
        },
        "&:hover": {
            backgroundColor: `${theme.palette.backgrounds.main} !important`,
        },
    },
}));
